import axios from "axios";
import { serverAddress } from "../../constant";
import cookie from 'js-cookie';
const PsbmAPI = {

    getAllPsbm: (params) => {
        // let url = serverAddress + `/api/psbm/get?page=${params?.page}&limit=${params?.limit}`;
        let url = serverAddress + `/psbm/get?page=${params?.page}&limit=${params?.limit}`;

        return axios.get(url,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },

        //confirm payment status ICDS
        confirmPaymentPsbm:(params)=>{
            // let url= `${serverAddress}/api/psbm/success/?_id=${params}`;
            let url= `${serverAddress}/psbm/success/?_id=${params}`;
            return axios.get(url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${cookie.get('ajwt')}`
                    },
                }
            );
        },

        sendLinkPsbm: (params) => {
            // let url = serverAddress + `/api/law/get/${params}`;
            let url = serverAddress + `/psbm/get/${params}`;
            return axios.get(url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${cookie.get('ajwt')}`
                    },
                }
            );
        },

            //updateTransactionID
    updateTransactionIdPsbm:(id,transactionId)=>{
        // let url= `${serverAddress}/api/psbm/transaction?_id=${id}&transactionId=${transactionId}`;
        let url= `${serverAddress}/psbm/transaction?_id=${id}&transactionId=${transactionId}`;

        return axios.post(url,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },


    approveAbstractPsbm:(id,email)=>{
        let url= `${serverAddress}/psbm/status?_id=${id}&status=1&email=${email}`
        return axios.get(url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${cookie.get('ajwt')}`
                    },
                })
    },
    
      rejectAbstractPsbm:(id,email)=>{
        let url= `${serverAddress}/psbm/status?_id=${id}&status=2&email=${email}`
        return axios.get(url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${cookie.get('ajwt')}`
                    },
                })
    },
    paymentEmailPsbm:(id,email)=>{
        let url= `${serverAddress}/psbm/status?_id=${id}&paymentstatus=1&email=${email}`
        return axios.get(url,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: `Bearer ${cookie.get('ajwt')}`
                    },
                })
    },
    
    //psbm dynamic filter
    dynamicFilter:(params,page,limit)=>{
        // let url=serverAddress+`/api/psbm/dynamicFilters?page=${page}&limit=${limit}`;
        let url=serverAddress+`/psbm/filter/dynamic?page=${page}&limit=${limit}`;
        return axios.post(url,params,{
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${cookie.get("ajwt")}`,
          },
        })
      },

      downloadDynamicFilter:(params,page,limit)=>{
        // let url=serverAddress+`/api/psbm/ExportDynamic?page=${page}&limit=${limit}`;
        let url=serverAddress+`/psbm/ExportDynamic?page=${page}&limit=${limit}`;
        return axios.post(url,params,{
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${cookie.get("ajwt")}`,
          },
        })
      },



// search in psbm psbm

searchQuery: (params,page,limit)=>{
    // let url=serverAddress+`/api/psbm/search?page=${page}&limit=${limit}`;
    let url=serverAddress+`/psbm/search?page=${page}&limit=${limit}`;
    return axios.post(url,params,{
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    })
  },

    /* Forget Password */
};

export default PsbmAPI;